module.exports = __webpack_public_path__ + "static/media/Wharfedale.310e6a4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Wharfedale.png
// module id = 26
// module chunks = 0